/**
 * Компонент не завершен
 * Экспериментальная копия reactApp/components/SharingWindow/SharingNew/Weblink/SharingNewWeblink.tsx
 * Изменения относительно оригинала помечены комментарием - tempexp_17779
 **/

import { Icon56LockOutline } from '@vkontakte/icons';
import { ReactComponent as LockIcon } from '@vkontakte/icons/src/svg/20/lock_outline_20.svg';
import { ReactComponent as UnlockIcon } from '@vkontakte/icons/src/svg/20/unlock_outline_20.svg';
import browser from 'Cloud/browser';
import config from 'Cloud/config';
import classNames from 'clsx';
import React, { type ReactElement, memo, useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IS_ONPREMISE, IS_TABLET_BROWSER } from 'reactApp/appHelpers/configHelpers';
import { abSharingLinkFakedoor } from 'reactApp/appHelpers/featuresHelpers';
import { disablePublicDownload } from 'reactApp/appHelpers/featuresHelpers/features/disablePublicDownload';
import { enabledPublicDownloadLimits, tooltipLimitSharing } from 'reactApp/appHelpers/featuresHelpers/features/publicDownloadLimits';
import { isPublicPasswordEnabled } from 'reactApp/appHelpers/featuresHelpers/features/publicPassword';
import { seoEnable } from 'reactApp/appHelpers/featuresHelpers/features/seoEnable';
import { showWeblinkListFileSharing } from 'reactApp/appHelpers/featuresHelpers/features/tabsFolderSharingDesign';
import { isThemedSharedModalItem } from 'reactApp/appHelpers/featuresHelpers/features/themedPublic';
import { unPublishHelper } from 'reactApp/appHelpers/publishHelper';
import { DownloadsCountDropdown } from 'reactApp/components/SharingNewBiz/DownloadsCountDropdown/DownloadsCountDropdown';
import { WeblinkPublicPassword } from 'reactApp/components/SharingNewBiz/WeblinkPublicPassword/WeblinkPublicPassword';
import { PaidFeatureBlock, SharingWidnowContext } from 'reactApp/components/SharingWindow/PaidFeaturesBlock/PaidFeatureBlock';
import { sendGa } from 'reactApp/components/SharingWindow/Sharing.helpers';
import { DomainAccess, EFrom, EPromoTooltip } from 'reactApp/components/SharingWindow/Sharing.types';
import FoldingOptionsList from 'reactApp/components/SharingWindow/SharingNew/FoldingOptionsList/FoldingOptionsList';
import { useOnboardingEnabled } from 'reactApp/components/SharingWindow/SharingNew/hooks/onboardingEnabled.hook';
import { useWeblinkOpened } from 'reactApp/components/SharingWindow/SharingNew/hooks/useWeblinkOpened.hook';
import { AutoDelete } from 'reactApp/components/SharingWindow/SharingNew/Weblink/AutoDelete/AutoDelete';
import { DISABLE_PUBLIC_DOWNLOAD_TOOLTIP_ID } from 'reactApp/components/SharingWindow/SharingNew/Weblink/DisablePublicDownload/Tooltip/Tooltip';
import { useSeoOption } from 'reactApp/components/SharingWindow/SharingNew/Weblink/hooks/useSeoOption';
import { PUBLIC_PASSWORD_TOOLTIP_ID } from 'reactApp/components/SharingWindow/SharingNew/Weblink/PublicPassword/Tooltip/Tooltip';
import { SHARING_VARIANT } from 'reactApp/components/SharingWindow/SharingNew/Weblink/WeblinkList/SharingNewWeblinkList.types';
import SharingOptionAccessRights from 'reactApp/components/SharingWindow/SharingOptions/SharingOptionAccessRights';
import SharingOptionAddPersonalAccess from 'reactApp/components/SharingWindow/SharingOptions/SharingOptionAddPersonalAccess';
import { SharingOptionDomain } from 'reactApp/components/SharingWindow/SharingOptions/SharingOptionDomain';
import { SharingOptionExpires } from 'reactApp/components/SharingWindow/SharingOptions/SharingOptionExpires';
import { renderUnpublishWeblinkDialog } from 'reactApp/components/SharingWindow/Weblink/SharingWeblink.helpers';
import { useIsWindowIntegrationSmall } from 'reactApp/hooks/useIsWindowIntegrationSmall';
import { getEditorsFor, getIsFileForCoEditing } from 'reactApp/modules/editor/editor.selectors';
import {
    getFeatureEditingNoneditableFormats,
    getFeaturePublicAutoDeletePromo,
    getFeaturePublicDomestic,
} from 'reactApp/modules/features/features.selectors';
import { getIntegrationClient } from 'reactApp/modules/integration/integration.selectors';
import { publishRequest } from 'reactApp/modules/modifying/modifying.actions';
import { loadPaidInfoRequest } from 'reactApp/modules/paidInfo/paidInfo.module';
import { getPublicSharingInfo } from 'reactApp/modules/public/public.actions';
import { getPublicLimits, getPublicPin } from 'reactApp/modules/public/public.selectors';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { isAutoDeleteEnabled } from 'reactApp/modules/sharedAutoDelete/sharedAutoDelete.selectors';
import { getItemById } from 'reactApp/modules/storage/storage.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { UserStorageSelectors } from 'reactApp/modules/user/userStorage';
import type { RootState } from 'reactApp/store';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';
import { CopyWeblink } from 'reactApp/ui/CopyWeblink/CopyWeblink';
import { MAX_SHOWN_COUNT, TOOLTIP_ID } from 'reactApp/ui/SharingTooltips/SharingTooltipPromo';
import { sendXray } from 'reactApp/utils/ga';
import { getPublicUrl } from 'reactApp/utils/urlHelper';

import type { IProps } from '../../Weblink/SharingWeblink.types';
import { InformerLimitSharing } from '../InformerLimitSharing/InformerLimitSharing';
import { ChangeDesign, PUBLIC_DESIGN_TOOLTIP_ID } from './ChangeDesign/ChangeDesign';
import { PublicPassword } from './PublicPassword/PublicPassword';
import styles from './SharingNewWeblinkTab.css';
import { SharingNewWeblinkList } from './WeblinkList/SharingNewWeblinkList';

const IS_FREE_B2B_BIZ_EDITORS_USER = config.get('FREE_B2B_BIZ_EDITORS_USER');

/* eslint-disable complexity */
// eslint-disable-next-line max-lines-per-function
export const SharingNewWeblinkTab = memo(function SharingNewWeblink(props: IProps): ReactElement | null {
    const {
        id,
        isOwn,
        item,
        from,
        isSharedOrMouted,
        gaSuffix,
        noEdit = false,
        isPublic,
        isPhone,
        onUnpublish,
        sendSharingContentAnalytics,
        withPromoTooltip,
        showListSharing,
        // tempexp_17779-start
        onboardingEnabled,
        // tempexp_17779-end
        openPersonalAccess,
        foldSettings,
        variant = SHARING_VARIANT.tabs,
        isEmbedded = false,
        folderName,
        formProps,
        onCloseModal,
    } = props;

    const dispatch = useDispatch();

    const [lastShownTooltip, setLastShownTooltip] = useState<EPromoTooltip | null>(null);

    const isPublished = Boolean(item?.weblink);
    const { isWeblinkOpened, setWeblinkOpened, isWeblinkInfoLoading } = useWeblinkOpened(from, isPublished);

    const itemStorage = useSelector(getCurrentStorage);
    const storage = item?.storage || itemStorage;
    const isAlbum = from === EFrom.ALBUMS || storage === EStorageType.albums;
    const { isTutoria } = useSelector(getIntegrationClient);
    const isBizUser = useSelector(UserSelectors.isBizUser);
    const isCorpUser = useSelector(UserSelectors.isCorpUser);
    const isDomesticFeatureEnabled = useSelector(getFeaturePublicDomestic);
    const editingNoneEditableFormatsFeature = useSelector((state: RootState) => {
        if (!item) {
            return;
        }
        return getFeatureEditingNoneditableFormats(state, {
            file: {
                ext: typeof item === 'object' && 'ext' in item ? item.ext : undefined,
                size: typeof item === 'object' && 'size' in item ? item.size : undefined,
            },
            storage,
        });
    });
    const isConvertFileForCoEditing = useSelector((state: RootState) => getIsFileForCoEditing(state, { ...item, ext: convertExt }));
    const isFileForCoEditing = useSelector((state: RootState) => getIsFileForCoEditing(state, item));
    const isEditable = !!useSelector((state: RootState) => getEditorsFor(state, convertExt ? { ...item, ext: convertExt } : item))?.length;
    const parent = useSelector((state: RootState) => getItemById(state, item?.parent || ''));
    const isAutodeleteFeatureEnabled = Boolean(useSelector(isAutoDeleteEnabled));
    const isAutodeletePromoFeatureEnabled = Boolean(useSelector(getFeaturePublicAutoDeletePromo));
    // tempexp_17605-start
    const pin = useSelector((state: RootState) => getPublicPin(state, item?.weblink || ''));
    const isPaidUser = useSelector(UserSelectors.isPaidUser);

    const { onboardingAllUsers, onboardingPaidUsers } = useOnboardingEnabled(onboardingEnabled);

    const canShareForDomestic = isBizUser || isCorpUser;
    const isStock = itemStorage === EStorageType.stock;
    const showDomesticSettings =
        (!isAlbum || !isStock) &&
        ((canShareForDomestic && Boolean(isDomesticFeatureEnabled)) ||
            showWeblinkListFileSharing ||
            variant === SHARING_VARIANT.redesign) &&
        isOwn;
    const convertExt = editingNoneEditableFormatsFeature?.ext || '';
    const isFolder = item?.isFolder;
    const isDocumentForEdit =
        (item?.kind === 'document' && IS_FREE_B2B_BIZ_EDITORS_USER) ||
        isFileForCoEditing ||
        (isConvertFileForCoEditing && !(IS_TABLET_BROWSER || browser.isIpadOs()) && isEditable);
    const isReadOnlyItem = !!item?.isReadOnly;
    // Исключаем стоки, у которых них нет публичной ссылки
    const publicUrl = (isPublished && getPublicUrl(item, isAlbum)) || '';
    const isReadOnlyParent = !!(parent && 'isReadOnly' in parent && parent?.isReadOnly);
    const isReadOnlyProperty = !isReadOnlyItem && isSharedOrMouted.isMounted ? isReadOnlyParent : isReadOnlyItem;
    const isReadOnly = isFolder ? isReadOnlyProperty : isReadOnlyProperty || !isDocumentForEdit;
    const showChangePassword = Boolean(
        !onboardingAllUsers && isWeblinkOpened && (isPublicPasswordEnabled || pin) && !isAlbum && isOwn && item?.isFolder && !isTutoria
    );
    // tempexp_17605-end

    const domainAccess = (item && 'weblinkDomainAccess' in item && item.weblinkDomainAccess) || DomainAccess.EXTERNAL;
    const showExpires = isStock || (!isAlbum && !isPublic && isOwn);
    const showAccessRights = !isAlbum && isOwn && domainAccess !== DomainAccess.EMAIL_LIST_ACCESS;
    // Отключаем платную фичу в Тутории
    const showAutoDeleteSettings =
        !onboardingAllUsers &&
        !isTutoria &&
        isOwn &&
        !isAlbum &&
        item?.isFolder &&
        !isSharedOrMouted.isMounted &&
        (isAutodeleteFeatureEnabled || isAutodeletePromoFeatureEnabled);

    // tempexp_17341-next-line
    const showChangeDesign =
        !onboardingAllUsers && isWeblinkOpened && isThemedSharedModalItem && !isAlbum && isOwn && item?.isFolder && !isTutoria && !isPhone;

    // tempexp_17847-start
    const downloadLimits = useSelector((state: RootState) => getPublicLimits(state, item?.weblink || ''));
    const showInformerLimitSharing = !onboardingAllUsers && enabledPublicDownloadLimits && !isPaidUser && downloadLimits?.left === 0;
    const showSharingTooltipPromo =
        !onboardingAllUsers && enabledPublicDownloadLimits && tooltipLimitSharing && !isPaidUser && isWeblinkOpened && !!downloadLimits;
    // tempexp_17847-end

    const isDownloadable = item?.weblinkDownloadable;

    const isWindowSmall = useIsWindowIntegrationSmall();

    const seoOption = useSeoOption(item, !isBizUser && !IS_ONPREMISE && !isSharedOrMouted.isMounted && seoEnable);

    // tempexp_17779-start

    const onCloseAccessClick = useCallback(() => {
        const onCloseAccess = () => {
            sendGa('unpublish');
            if (storage === EStorageType.attaches) {
                sendGa('attaches-unpublish');
            }

            if (!item) {
                return;
            }

            unPublishHelper({ items: [item] });

            setWeblinkOpened(false);
            onUnpublish?.();
        };

        renderUnpublishWeblinkDialog({ onActionClick: onCloseAccess, variant });
    }, [variant, storage, item, setWeblinkOpened, onUnpublish]);

    const tooltipDownloadLimits = useSelector((state) => UserStorageSelectors.get(state, TOOLTIP_ID));
    const showDownloadLimitsTip =
        showSharingTooltipPromo &&
        (!lastShownTooltip || lastShownTooltip === EPromoTooltip.SharingDownloadLimits) &&
        (withPromoTooltip === EPromoTooltip.SharingDownloadLimits || !(tooltipDownloadLimits > MAX_SHOWN_COUNT));

    const tooltipPasswordShown = useSelector((state) => UserStorageSelectors.get(state, PUBLIC_PASSWORD_TOOLTIP_ID));
    const defaultShowPublicPasswordTip =
        showChangePassword &&
        (!lastShownTooltip || lastShownTooltip === EPromoTooltip.PublicPassword) &&
        !isPhone &&
        !isPaidUser &&
        (withPromoTooltip === EPromoTooltip.PublicPassword || (!tooltipPasswordShown && !isCorpUser && !showDownloadLimitsTip));

    const showPublicPasswordTip =
        enabledPublicDownloadLimits && !isPaidUser
            ? defaultShowPublicPasswordTip && tooltipDownloadLimits > MAX_SHOWN_COUNT
            : defaultShowPublicPasswordTip;

    const tooltipDesignShown = Boolean(useSelector((state) => UserStorageSelectors.get(state, PUBLIC_DESIGN_TOOLTIP_ID)));
    const defaultShowPublicDesignTip =
        showChangeDesign &&
        (!lastShownTooltip || lastShownTooltip === EPromoTooltip.ChangeDesign) &&
        (withPromoTooltip === EPromoTooltip.ChangeDesign || (!tooltipDesignShown && !showPublicPasswordTip && !showDownloadLimitsTip));
    const showPublicDesignTip =
        enabledPublicDownloadLimits && !isPaidUser
            ? defaultShowPublicDesignTip && tooltipDownloadLimits > MAX_SHOWN_COUNT
            : defaultShowPublicDesignTip;

    const showDisablePublicDownload =
        isWeblinkOpened && !isBizUser && !IS_ONPREMISE && !isSharedOrMouted.isMounted && disablePublicDownload;
    const tooltipDisableDownloadShown = Boolean(
        useSelector((state) => UserStorageSelectors.get(state, DISABLE_PUBLIC_DOWNLOAD_TOOLTIP_ID))
    );

    const defaultShowDisableDownloadTip =
        showDisablePublicDownload &&
        (!lastShownTooltip || lastShownTooltip === EPromoTooltip.DisablePublicDownload) &&
        (withPromoTooltip === EPromoTooltip.DisablePublicDownload ||
            (!tooltipDisableDownloadShown && !showPublicDesignTip && !showPublicPasswordTip && !showDownloadLimitsTip));

    const showDisableDownloadTip =
        enabledPublicDownloadLimits && !isPaidUser
            ? defaultShowDisableDownloadTip && tooltipDownloadLimits > MAX_SHOWN_COUNT
            : defaultShowDisableDownloadTip;

    if (!lastShownTooltip) {
        if (showDownloadLimitsTip) {
            setLastShownTooltip(EPromoTooltip.SharingDownloadLimits);
        } else if (showPublicPasswordTip) {
            setLastShownTooltip(EPromoTooltip.PublicPassword);
        } else if (showPublicDesignTip) {
            setLastShownTooltip(EPromoTooltip.ChangeDesign);
        } else if (showDisableDownloadTip) {
            setLastShownTooltip(EPromoTooltip.DisablePublicDownload);
        }
    }
    // tempexp_17779-end
    const onDropdownClick = useCallback(() => {
        sendSharingContentAnalytics({ action: 'auto-delete', label: 'click' });
    }, [sendSharingContentAnalytics]);

    // tempexp_17779-start
    const onOpenAccessClick = useCallback(() => {
        if (!item) {
            return;
        }

        sendGa('publish');
        dispatch(publishRequest({ item }));
    }, [dispatch, item]);
    // tempexp_17779-end

    useEffect(() => {
        if (item?.weblink) {
            dispatch(getPublicSharingInfo({ public_id: item.weblink }));
            // todo: заменить на новую ручку.
            dispatch(loadPaidInfoRequest());
        }

        if (showChangePassword && !isPaidUser) {
            dispatch(loadPaidInfoRequest());
        }
    }, [dispatch, isPaidUser, item?.weblink, showChangePassword]);

    useEffect(() => {
        if (item?.weblink) {
            setWeblinkOpened(true);
        } else if (!publicUrl) {
            setWeblinkOpened(false);
        }
    }, [item?.weblink, publicUrl, setWeblinkOpened]);

    const showPromoTooltip = useMemo(() => {
        if ((!lastShownTooltip || lastShownTooltip === EPromoTooltip.PublicPassword) && Boolean(showPublicPasswordTip)) {
            return EPromoTooltip.PublicPassword;
        } else if ((!lastShownTooltip || lastShownTooltip === EPromoTooltip.ChangeDesign) && Boolean(showPublicDesignTip)) {
            return EPromoTooltip.ChangeDesign;
        }
    }, [lastShownTooltip, showPublicPasswordTip, showPublicDesignTip]);

    useEffect(() => {
        let type = 'file';
        const userType = isBizUser ? 'biz' : 'b2c';

        if (isFolder) {
            type = 'folder';
        } else if (isAlbum) {
            type = 'album';
        }

        sendXray(['sharing-weblink-info-mount', type, userType]);
    }, []);

    if (!isWeblinkOpened && !isWeblinkInfoLoading) {
        return (
            <div className={styles.emptyContainer} data-qa-id="sharing-access-disabled-state">
                {variant === SHARING_VARIANT.biz ? (
                    <Icon56LockOutline className={styles.emptyStateIcon} />
                ) : (
                    <div className={styles.emptyImage} />
                )}
                <h3 className={styles.emptyHeader}>Доступ по ссылке закрыт</h3>
                <p className={styles.emptyDescription}>
                    Если передумаете — создадим новую ссылку,
                    <br />
                    ей можно будет поделиться
                </p>
                {!isPublic && (
                    <Button
                        qaId="sharing-enable-button"
                        theme={'base'}
                        middle
                        onClick={onOpenAccessClick}
                        sizeMode={isPhone ? ButtonSizeMode.big : ButtonSizeMode.middle}
                    >
                        <div className={styles.closeAccessButton}>
                            {variant !== SHARING_VARIANT.biz && <UnlockIcon width={20} height={20} />}
                            <span>Открыть доступ</span>
                        </div>
                    </Button>
                )}
            </div>
        );
    }
    // tempexp_17779-end

    if (!item) {
        onCloseModal();
        return null;
    }

    return (
        <div data-qa-section="weblink">
            <div
                className={classNames(styles.root, {
                    [styles.root_phone]: isPhone,
                    [styles.root_tutoria]: isWindowSmall,
                    [styles.onboardingPaid]: onboardingPaidUsers,
                })}
            >
                {showInformerLimitSharing && <InformerLimitSharing isMobile={isPhone} total={downloadLimits?.total} />}

                {isBizUser && openPersonalAccess && (
                    <SharingOptionAddPersonalAccess
                        variant={SHARING_VARIANT.biz}
                        item={item}
                        onClick={openPersonalAccess}
                        domainAccess={domainAccess}
                        isEmbedded={isEmbedded}
                    />
                )}

                {/* tempexp_17605-next-line */}
                {showChangePassword && (
                    <PublicPassword forcePromo={showPromoTooltip === EPromoTooltip.PublicPassword} item={item} isTabsDesign />
                )}
                {/* tempexp_17341-next-line */}

                {showChangeDesign && <ChangeDesign item={item} forcePromo={showPromoTooltip === EPromoTooltip.ChangeDesign} isTabsDesign />}

                {seoOption}

                {showDomesticSettings && (
                    <SharingOptionDomain
                        item={item}
                        storage={storage}
                        canShareForDomestic={canShareForDomestic}
                        redesign
                        showSharingTooltipPromo={showSharingTooltipPromo}
                        downloadLimits={downloadLimits}
                        isBizUser={isBizUser}
                        formProps={formProps}
                        pin={pin}
                        onCloseModal={onCloseModal}
                    />
                )}

                {showAccessRights && item && (
                    <SharingOptionAccessRights
                        item={item}
                        isReadOnly={isReadOnly}
                        isReadOnlyProperty={isReadOnlyProperty}
                        onUnpublish={onUnpublish}
                        redesign={true}
                        showSharingTooltipPromo={showSharingTooltipPromo}
                        downloadLimits={downloadLimits}
                        isBizUser={isBizUser}
                        isDownloadable={isDownloadable}
                    />
                )}

                {!foldSettings && showExpires && <SharingOptionExpires item={item} redesign />}

                {isBizUser && <WeblinkPublicPassword storage={storage} pin={pin} item={item} formProps={formProps} redesign />}

                {!isBizUser && openPersonalAccess && (
                    <SharingOptionAddPersonalAccess
                        item={item}
                        onClick={openPersonalAccess}
                        domainAccess={domainAccess}
                        isEmbedded={isEmbedded}
                    />
                )}

                {foldSettings &&
                    (isBizUser ? (
                        <FoldingOptionsList open={onboardingAllUsers} description="срок действия, кол-во скачиваний">
                            {showExpires && <SharingOptionExpires item={item} redesign />}
                            <DownloadsCountDropdown redesign item={item} isDownloadable={isDownloadable} />
                        </FoldingOptionsList>
                    ) : (
                        <FoldingOptionsList open={onboardingAllUsers} description="доступ, срок действия">
                            {showExpires && <SharingOptionExpires item={item} redesign />}
                            {showAutoDeleteSettings && (
                                <AutoDelete
                                    item={item}
                                    isTabs
                                    disabled={!isAutodeleteFeatureEnabled && isAutodeletePromoFeatureEnabled && isWeblinkOpened}
                                    gaSuffix={gaSuffix}
                                    onDropdownClick={onDropdownClick}
                                    disabledBySeo={item?.weblinkSeoEnabled && seoEnable}
                                />
                            )}
                        </FoldingOptionsList>
                    ))}

                {onboardingPaidUsers ? (
                    <PaidFeatureBlock
                        context={SharingWidnowContext.TAB}
                        isTabDesing
                        from={from}
                        id={id}
                        isPhone={isPhone}
                        itemStorage={itemStorage}
                    />
                ) : null}
            </div>

            {showWeblinkListFileSharing && !noEdit && showListSharing && (
                <div className={styles.personalAccessContainer}>
                    <SharingNewWeblinkList item={item} from={from} isPhone={isPhone} isReadOnly={isReadOnly} variant={variant} />
                </div>
            )}

            {/* tempexp_17779-start */}
            <div className={styles.copyWeblink}>
                <CopyWeblink
                    type="sharingTabs"
                    publicUrl={publicUrl}
                    autoCopy={!isPhone}
                    isPhone={isPhone}
                    redesignIcon={!isFolder}
                    isFolder={isFolder}
                    isDownloadable={item?.weblinkDownloadable}
                    weblinkAccessRights={item?.weblinkAccessRights}
                    folderName={folderName}
                    weblinkDomestic={item?.weblinkDomestic}
                    // tempexp_17341-next-line
                    tooltipEnabledByExp={abSharingLinkFakedoor === 'b' && !isThemedSharedModalItem}
                    item={item}
                    // tempexp_17341-next-line
                    showOtherSharingTooltipPromo={!isPhone}
                    fileName={item?.name}
                />
                <Button
                    qaId="sharing-close-access"
                    className={styles.btnContainer}
                    theme={'base'}
                    middle
                    onClick={onCloseAccessClick}
                    sizeMode={isPhone ? ButtonSizeMode.big : ButtonSizeMode.middle}
                >
                    <div className={styles.closeAccessButton}>
                        <LockIcon width={20} height={20} />
                        <span>Закрыть доступ{isFolder && ' по ссылке'}</span>
                    </div>
                </Button>
            </div>
            {/* tempexp_17779-end */}
        </div>
    );
});
